<template>
    <div>
        <Card>
          <Form>
            <FormItem :label-width="80" label="大类">
                  <Input :value="MaterialCategoryName" readonly></Input>
            </FormItem>
          </Form>
        </Card>
        <Card style="margin-top:.5rem">
          <Table :columns="column" :data="lists" max-height="400">
            <template slot-scope="{ row, index }" slot="AttributesValueIDList">
              <Select v-model="lists[index].SelectionValue" style="width:200px" filterable transfer>
                  <Option v-for="item in row.AttributesValueIDList" :value="item.Attributes_value_ID" :key="item.Attributes_value_ID">{{ item.Name }}</Option>
              </Select>
            </template>
          </Table>
        </Card>
        <Card style="margin-top:.5rem">
          <Form>
            <FormItem :label-width="80" label="变动价格">
                  <InputNumber :min="0" v-model="ChangePrice"></InputNumber>
                  <Button type="primary" style="margin-left:1rem" @click="HandleClick(1)">升价</Button>
                  <Button type="primary" style="margin-left:1rem" @click="HandleClick(-1)">降价</Button>
            </FormItem>
          </Form>
        </Card>
        <Card style="margin-top:1rem">
          <p slot="title">价格变更记录</p>
          <Table :columns="column2" :data="lists2" max-height="400"/>
          <Page :total="total"
          show-sizer show-elevator style="margin:1rem 0 .3rem 0;text-align: center;"
          @on-change="PageChangeHandleClick" @on-page-size-change="PageSizeChangeHandleClick"/>
        </Card>
        <Spin size="large" fix v-if="SpinShow"></Spin>
    </div>
</template>

<script>
import { GetBatchData, ChangeBatchData, GetChangePriceLog } from '@/api/PriceRules'
export default {
  name: 'BatchData',
  props: {
    MaterialCategoryID: String,
    MaterialCategoryName: String,
    Price_rules_ID: String
  },
  data () {
    return {
      column: [
        {
          title: '中类',
          key: 'AttributesName'
        },
        {
          title: '小类',
          slot: 'AttributesValueIDList'
        }
      ],
      lists: [],
      ChangePrice: 0,
      column2: [
        {
          title: '日期时间',
          key: 'Date'
        },
        {
          title: '升/降价',
          key: 'ChangeType'
        },
        {
          title: '变动价格',
          key: 'ChangePrice'
        },
        {
          title: '变价大类',
          key: 'MaterialCategory'
        },
        {
          title: '详情',
          key: 'details'
        }
      ],
      lists2: [],
      total: 0,
      CurrentPage: 1,
      pageSize: 10,
      SpinShow: false
    }
  },
  mounted: function () {
    this.GetBatchList()
    this.GetLogData()
  },
  methods: {
    GetBatchList () {
      GetBatchData(this.Price_rules_ID).then((res) => {
        if (res.IsSuccess) {
          this.lists = res.Data
        } else {
          this.$Message.error(res.Message)
        }
      })
    },
    // 获取日志数据
    GetLogData () {
      GetChangePriceLog(this.MaterialCategoryID, this.CurrentPage, this.pageSize).then((res) => {
        if (res.IsSuccess) {
          this.total = res.Data.Table[0].total
          this.lists2 = res.Data.Table1
        } else {
          this.$Message.error(res.Message)
        }
      })
    },
    // 切换页数
    PageChangeHandleClick (res) {
      if (this.CurrentPage !== res) {
        this.CurrentPage = res
        this.GetLogData()
      }
    },
    // 每页数据量改变
    PageSizeChangeHandleClick (res) {
      if (this.pageSize !== res) {
        this.pageSize = res
        this.GetLogData()
      }
    },
    // 价格变化回调
    HandleClick (type) {
      this.SpinShow = true
      if (this.ChangePrice > 0) {
        let isPet = false
        let isColour = true
        let isCrossSection = false
        if (this.MaterialCategoryName === 'PET打包带') {
          isPet = true
        }
        var list = new Array(0)
        if (this.lists.length > 0) {
          this.lists.forEach(item => {
            if (isPet && item.AttributesName === '颜色' && item.SelectionValue === 'Blankid') {
              isColour = false
            }
            if (isPet && item.AttributesName === '横截面' && item.SelectionValue !== 'Blankid') {
              isCrossSection = true
            }
            list.push({
              AttributesID: item.AttributesID,
              AttributesName: item.AttributesName,
              SelectionValue: item.SelectionValue
            })
          })
        }
        if ((isCrossSection && isColour) || !isCrossSection) {
          // 调用接口
          ChangeBatchData({
            Price_rules_ID: this.Price_rules_ID,
            MaterialCategoryID: this.MaterialCategoryID,
            MaterialCategoryName: this.MaterialCategoryName,
            ChangePrice: this.ChangePrice,
            type: type,
            Batchlist: list
          }).then((res) => {
            if (res.IsSuccess) {
              this.$Message.success('修改成功！')
              this.GetLogData()
              this.$emit('PriceRuleSelectHandleClick', this.Price_rules_ID)
              this.SpinShow = false
            } else {
              this.$Message.error(res.Message)
              this.SpinShow = false
            }
          })
        } else {
          this.$Message.error('选择横截面的时候需要同时选择颜色。')
          this.SpinShow = false
        }
      } else {
        this.$Message.error('请先填写需要调整的价格。')
        this.SpinShow = false
      }
    }
  }
}
</script>
